export default __webpack_public_path__ + "static/media/neutral-emoji.ba0f1662.png";